import {
  CardBody,
  CardButtonWrapper,
  CardInformative,
  CardSupport,
  CustomDivider,
  ListItemModifier,
  TagLayout,
  TagWrapper
} from './style';
import { InformativeTag, Label, List, ListItem, MainButton } from '@icarros/ids-react';
import {
  formatFabricationAndModelYear,
  formatPriceToReal,
  removePlural
} from '../../../../utils/formatters';

import { CardOptions } from './CardOptions';
import { CardProps } from './constants';
import { LISTING } from '../../../../../utils/routes';
import React from 'react';
import { getFirstImage } from '../../../../utils/getFirstImage';
import { pushSellerPFDashboardEvent } from '../../../../../utils/pushToDataLayer';
import { useHistory } from 'react-router-dom';
import { useWebappFlags } from '../../../../hooks/useWebAppFlags';

export function Analyzing({ card }: CardProps): JSX.Element {
  const history = useHistory();
  const { getFlagOnSession } = useWebappFlags();

  return (
    <>
      <div>
        <img src={getFirstImage(card.fotos)} alt="Primeira imagem do anuncio" />
      </div>
      <CardBody>
        <CardSupport>
          <CardInformative>
            {card.filterText && (
              <InformativeTag variant="outlined" type="error">
                {removePlural(card.filterText)}
              </InformativeTag>
            )}
          </CardInformative>
          <CardOptions editId={card.id} showDelete showHelp showEdit />
        </CardSupport>
        <List>
          <ListItemModifier>
            <ListItem
              hasLine={false}
              label={`${card.veiculo.marca.nome} ${card.veiculo.modelo.nome}`}
              subLabel={`${card.veiculo.versao.nome} ${formatFabricationAndModelYear(
                card.veiculo.anoFabricacao,
                card.veiculo.anoModelo
              )}`}
              variant="action"
              actionOnClick={() => {
                pushSellerPFDashboardEvent('>');
                history.push(`${LISTING}/${card.id}`);
              }}
            />
          </ListItemModifier>
        </List>
        <TagLayout>
          <Label size="medium" variant="neutral" weight="bold">
            {formatPriceToReal(card.valorVenda)}
          </Label>
          {card.chassiVerificado?.status && getFlagOnSession('validacaoChassi') && (
            <TagWrapper>
              <InformativeTag type="success" variant="outlined">
                Placa e chassi verificados
              </InformativeTag>
            </TagWrapper>
          )}
        </TagLayout>
        <CustomDivider variant="primary" />
        <CardButtonWrapper>
          <MainButton
            text="Editar"
            variant="secondary"
            onClick={() => {
              pushSellerPFDashboardEvent('editar anúncio');
              history.push(`${LISTING}/${card.id}`);
            }}
          />
        </CardButtonWrapper>
      </CardBody>
    </>
  );
}
